import { motion } from 'framer-motion'
import { Briefcase, DollarSign, BarChart3, TrendingUp } from 'lucide-react'

const stats = [
  { icon: DollarSign, value: '$120K+', label: 'Average DevOps Salary' },
  { icon: Briefcase, value: '10K+', label: 'Open DevOps Roles Monthly' },
  { icon: BarChart3, value: '35%', label: 'Annual Cloud Hiring Growth' },
  { icon: TrendingUp, value: '3x', label: 'Faster Career Growth' },
]

const MarketingSection = () => {
  return (
    <section className="section-padding bg-gray-900 text-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">Why DevOps Is the Best Career Move Right Now</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">Cloud-native companies are aggressively hiring engineers who can automate, scale, and deploy with confidence.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {stats.map((item, index) => (
            <motion.div key={item.label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.08 }} className="glass rounded-2xl p-6 text-center bg-white/5 border-white/10">
              <item.icon className="w-10 h-10 text-accent-400 mx-auto mb-4" />
              <div className="text-3xl font-bold mb-2">{item.value}</div>
              <div className="text-gray-300">{item.label}</div>
            </motion.div>
          ))}
        </div>
        <div className="grid lg:grid-cols-3 gap-6">
          <div className="card p-6 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            <h3 className="text-xl font-semibold mb-3">Companies Hiring</h3>
            <p className="text-gray-600 dark:text-gray-400">Amazon, Microsoft, Google, Accenture, IBM, Infosys, TCS, Wipro, Deloitte, and high-growth startups.</p>
          </div>
          <div className="card p-6 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            <h3 className="text-xl font-semibold mb-3">Career Transformation</h3>
            <p className="text-gray-600 dark:text-gray-400">Move from support, sysadmin, QA, networking, or development into cloud and platform engineering roles.</p>
          </div>
          <div className="card p-6 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            <h3 className="text-xl font-semibold mb-3">Industry Demand</h3>
            <p className="text-gray-600 dark:text-gray-400">DevOps, Kubernetes, Terraform, and cloud automation remain core skills in modern software teams.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MarketingSection
